import { tr, localizedStatic } from "@/i18n/copy";
// Registry only: entries become visible when their implementation is added.
// It deliberately contains no SaaS plan or Team-capability conditions.
export const CLIENT_MODULES = localizedStatic([
  { id: "home", label: "Home", implemented: true },
  { id: "qr", label: "My QR", implemented: true },
  { id: "artists", label: "Artists", implemented: true },
  // Portfolio is reachable inside the implemented Artist Detail, not a
  // standalone Client destination.
  { id: "portfolio", label: "Portfolio", implemented: false },
  { id: "booking", label: "Prenota", implemented: true },
  { id: "appointments", label: "Appuntamenti", implemented: true },
  { id: "consents", label: "Consensi", implemented: true },
  { id: "quotations", label: "Preventivi", implemented: true },
  { id: "history", label: "I miei tattoo", implemented: true },
  { id: "notifications", label: "Notifiche", implemented: true },
], [[0,"label"],[1,"label"],[2,"label"],[3,"label"],[4,"label"],[5,"label"],[6,"label"],[7,"label"],[8,"label"],[9,"label"]]);

export function availableClientModules() {
  return CLIENT_MODULES.filter((module) => module.implemented);
}
